var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M28.125 6.25C19.9375 6.25 13.2812 12.9063 13.2812 21.0938C13.2812 29.125 19.5625 35.625 27.75 35.9062C28 35.875 28.25 35.875 28.4375 35.9062C28.5 35.9062 28.5312 35.9062 28.5938 35.9062C28.625 35.9062 28.625 35.9062 28.6563 35.9062C36.6563 35.625 42.9375 29.125 42.9688 21.0938C42.9688 12.9063 36.3125 6.25 28.125 6.25Z",
    fill: "#1D9CFD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 44.2188C35.2812 38.4062 21.0625 38.4062 12.2812 44.2188C8.3125 46.875 6.125 50.4688 6.125 54.3125C6.125 58.1563 8.3125 61.7188 12.25 64.3438C16.625 67.2813 22.375 68.75 28.125 68.75C33.875 68.75 39.625 67.2813 44 64.3438C47.9375 61.6875 50.125 58.125 50.125 54.25C50.0938 50.4063 47.9375 46.8438 44 44.2188Z",
    fill: "#1D9CFD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M62.4688 22.9366C62.9688 28.9991 58.6563 34.3116 52.6875 35.0303C52.6563 35.0303 52.6563 35.0303 52.625 35.0303H52.5312C52.3438 35.0303 52.1562 35.0303 52 35.0928C48.9687 35.2491 46.1875 34.2803 44.0938 32.4991C47.3125 29.6241 49.1563 25.3116 48.7813 20.6241C48.5625 18.0928 47.6875 15.7803 46.375 13.8116C47.5625 13.2178 48.9375 12.8428 50.3438 12.7178C56.4688 12.1866 61.9375 16.7491 62.4688 22.9366Z",
    fill: "#1D9CFD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7187 51.843C68.4687 54.8743 66.5312 57.4993 63.2812 59.2805C60.1562 60.9993 56.2187 61.8118 52.3125 61.718C54.5625 59.6868 55.875 57.1555 56.125 54.468C56.4375 50.593 54.5938 46.8743 50.9063 43.9055C48.8125 42.2493 46.375 40.9368 43.7188 39.968C50.625 37.968 59.3125 39.3118 64.6562 43.6243C67.5312 45.9368 69 48.843 68.7187 51.843Z",
    fill: "#1D9CFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUser);
export default __webpack_public_path__ + "static/media/profile-user.b5b45fa24167a1342e4a61b1e0982d66.svg";
export { ForwardRef as ReactComponent };